import { css } from '@emotion/core';
import { rgba, variables as vars, media, tokens } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font,
  global = vars.global;
var colors = tokens.colors;
export var actionPopup = /*#__PURE__*/css("display:inline-block;position:absolute;border:1px solid ", colour.neutral100, ";pointer-events:auto;background-color:", colour.white, ";box-shadow:0 1px 8px 0 ", rgba(colour.black, 0.15), ";z-index:", Number(global.layerFloating) + 1, ";width:315px;top:55px;left:-240px;", media('>=tablet'), "{left:-180px;&::after,&::before{bottom:100%;left:90%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;border-color:", rgba(colour.white, 0), ";}&::before{border-bottom-color:", colour.neutral200, ";border-width:10px;margin-left:-10px;top:-21px;}&::after{border-bottom-color:", colour.white, ";border-width:10px;margin-left:-10px;}}");
export var noLocationMessage = /*#__PURE__*/css("color:", colour.neutral600, ";font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";line-height:1.5;padding:20px;");
export var confirmContent = {
  name: "uoqysr",
  styles: "height:125px;width:100%;min-height:85px;text-align:left;"
};
export var confirmHeading = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";font-family:", font.bodyFontFamily, ";font-size:", font.h4FontSize, ";font-weight:", font.headingFontWeight, ";line-height:27px;position:absolute;top:22px;width:215px;margin-left:48px;");
export var tickIconWrapper = {
  name: "1vfwh6y",
  styles: "position:absolute;top:18px;left:10px;"
};
export var tickIcon = /*#__PURE__*/css("position:absolute;top:1px;right:1px;color:", colour.link, ";width:18px;height:18px;");
export var eaIconWrapper = {
  name: "1fhgjcy",
  styles: "margin-top:4px;"
};
export var confirmMessageWrapper = {
  name: "1pymt1n",
  styles: "display:flex;position:absolute;top:80px;left:17px;margin-right:20px;"
};
export var confirmMessage = /*#__PURE__*/css("padding-top:50px;color:", colors.neutral.heavy.default, ";margin:14px 17px;white-space:normal;", media('>=tablet'), "{padding-top:50px;}");
export var bold = {
  name: "35ezg3",
  styles: "font-weight:600;"
};
export var buttonWrapper = {
  name: "64y5e3",
  styles: "position:absolute;top:70px;left:20px;margin-top:5px;.button{outline:0;display:block;font-weight:600;}"
};
export var menuContent = {
  name: "urstm5",
  styles: "height:280px;width:100%;min-height:85px;display:flex;flex-direction:column;"
};
export var menuButtonWrapper = {
  name: "bo4w4y",
  styles: "padding:0 20px 20px;display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;"
};
export var menuTitle = /*#__PURE__*/css("color:", colour.neutral600, ";font-family:", font.headingFontFamily, ";font-size:", font.h4FontSize, ";font-weight:600;line-height:1.33;margin:20px 20px 0;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var menuSubTitle = /*#__PURE__*/css("color:", colour.neutral500, ";font-size:", font.smallFontSize, ";line-height:1.71;padding-bottom:16px;margin:0 20px;height:38px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var divider = /*#__PURE__*/css("margin-bottom:10px;border-bottom:1px solid ", colour.neutral200, ";");
export var menuButton = {
  name: "r5gzls",
  styles: "text-align:left;padding:0;"
};
export var popupStyle = /*#__PURE__*/css("padding-bottom:15px;", media('>=tablet'), "{padding-bottom:25px;}");